import script from "./ChangeOrganizationPartnerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChangeOrganizationPartnerModal.vue?vue&type=script&setup=true&lang=ts"

import "./ChangeOrganizationPartnerModal.vue?vue&type=style&index=0&id=1e99cbd7&scoped=true&lang=css"
script.__scopeId = "data-v-1e99cbd7"

export default script